import GlobalStyles from "./styles/GlobalStyles";
import Router from "./Router";

function App() {
  return (
    <>
      <GlobalStyles />
      <Router />
    </>
  );
}

export default App;
